import { render } from "./VideoCp.vue?vue&type=template&id=c7173e64&scoped=true"
import script from "./VideoCp.vue?vue&type=script&lang=js"
export * from "./VideoCp.vue?vue&type=script&lang=js"

import "./VideoCp.vue?vue&type=style&index=0&id=c7173e64&scoped=true&lang=scss"
import "./VideoCp.vue?vue&type=style&index=1&id=c7173e64&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7173e64"]])

export default __exports__